export default __webpack_public_path__ + "static/media/banner4.4335d2ce.png";